import { isWithinTokenLimit } from "gpt-tokenizer/encoding/cl100k_base";

export const CHAT_INPUT_TOKEN_LIMIT = 10_000;
export const CHAT_FILE_BYTE_LIMIT = 10 * 1024 * 1024;
export const CHAT_TEXT_BYTE_LIMIT = 256 * 1024;
export const CHAT_INPUT_LIMIT_MESSAGE = "This message and its attachments exceed the 10,000-token chat limit. Shorten the message or use Import contacts/companies for a full list.";

const encoder = new TextEncoder();
const literalTextOptions = { disallowedSpecial: new Set<string>() };

// One stable browser/server admission budget, not an exact Claude billing count.
// The byte ceiling also bounds tokenizer work on highly repetitive input.
export function chatInputLimitError(parts: Iterable<{ type: string; text?: string }>): string | undefined {
    let remainingTokens = CHAT_INPUT_TOKEN_LIMIT;
    let remainingBytes = CHAT_TEXT_BYTE_LIMIT;
    for (const part of parts) {
        if (part.type !== "text" || part.text === undefined) continue;
        if (part.text.length > remainingBytes) return CHAT_INPUT_LIMIT_MESSAGE;
        remainingBytes -= encoder.encode(part.text).byteLength;
        if (remainingBytes < 0) return CHAT_INPUT_LIMIT_MESSAGE;
        const tokens = isWithinTokenLimit(part.text, remainingTokens, literalTextOptions);
        if (tokens === false) return CHAT_INPUT_LIMIT_MESSAGE;
        remainingTokens -= tokens;
    }
}

export class ChatInputLimitError extends Error {
    constructor() {
        super(CHAT_INPUT_LIMIT_MESSAGE);
        this.name = "ChatInputLimitError";
    }
}
